import { Link, useLocation } from "react-router-dom";
import { Eye, Menu, Plus } from "lucide-react";
import { useAuth } from "../../auth/context";
import Button from "../ui/Button";

// Page title per admin route, so the top bar always says where you are.
const titleFor = (pathname) => {
  if (pathname === "/") return "Dashboard";
  if (pathname === "/apps/new") return "New app";
  if (/^\/apps\/.+\/edit$/.test(pathname)) return "Edit app";
  if (pathname.startsWith("/apps")) return "Apps";
  if (pathname.startsWith("/installs")) return "Installs";
  if (pathname.startsWith("/activity")) return "Activity logs";
  if (pathname.startsWith("/app-events")) return "App events";
  if (pathname.startsWith("/team")) return "Team";
  if (pathname.startsWith("/analytics")) return "Analytics";
  if (pathname.startsWith("/companies")) return "Companies";
  if (pathname.startsWith("/locations")) return "Locations";
  if (pathname.startsWith("/users")) return "Users";
  if (pathname.startsWith("/feature-requests")) return "Feature requests";
  if (pathname.startsWith("/support")) return "Support";
  if (pathname.startsWith("/announcements")) return "Announcements";
  if (pathname.startsWith("/notifications")) return "Notifications";
  return "Admin";
};

const DefaultHeader = ({ onToggleSidebar }) => {
  const { pathname } = useLocation();
  const { canEdit } = useAuth();
  const onAppsList = pathname === "/apps" && canEdit;

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-ink-200/70 bg-white/80 px-5 backdrop-blur-xl">
      <button
        onClick={onToggleSidebar}
        className="grid h-9 w-9 place-items-center rounded-lg text-ink-500 hover:bg-ink-100 hover:text-ink-900 lg:hidden"
        aria-label="Open menu"
      >
        <Menu size={18} />
      </button>

      <h1 className="text-sm font-semibold tracking-tight text-ink-900">
        {titleFor(pathname)}
      </h1>

      <div className="ml-auto flex items-center gap-2">
        {!canEdit && (
          <span title="Your role can see every page but not change anything." className="inline-flex items-center gap-1.5 rounded-full bg-ink-100 px-2.5 py-1 text-[11.5px] font-medium text-ink-600">
            <Eye size={12} aria-hidden />
            View only
          </span>
        )}
        {onAppsList && (
          <Button
            as={Link}
            to="/apps/new"
            size="sm"
            variant="gradient"
            icon={<Plus size={14} strokeWidth={2.5} />}
          >
            <span className="hidden sm:inline">New app</span>
          </Button>
        )}
      </div>
    </header>
  );
};

export default DefaultHeader;
